'use strict';
import $ from 'jquery';

export default API => {
	API.orderView = () => {
		API.log('INIT orderView');

		const openShipmentHistory = ($shipment) => {
			history.pushState(null, '', '');
			$.magnificPopup.open({
				items: { src: $shipment.find('.shipment-status-history') },
				type: 'inline',
				mainClass: 'v4-typography modal-layer',
				closeMarkup: '<button type="button" class="mfp-close"><i class="is-icon is-icon-close"></i> %title%</button>',
				tClose: 'Sulje',
				gallery: {
					enabled: true,
					arrowMarkup: '<button type="button" type="button" class="mfp-arrow mfp-arrow-%dir%"><i class="is-icon is-icon-arrow mfp-prevent-close"></i> <span class="mfp-arrow-title mfp-prevent-close">%title%</span></button>',
					tPrev: '',
					tNext: '',
					tCounter: ''
				}
			});
		}

		const closeShipmentHistory = () => $.magnificPopup.close();
		window.onpopstate = closeShipmentHistory;

		$('.order-tracking-codes .track-shipment').on('click', (e) => {
			e.preventDefault();
			const $shipment = $(e.target).closest('.shipment');
			openShipmentHistory($shipment);
		});

		$('.accordion-link').on('click', (e) => {
			e.preventDefault();
			const href = $(e.target).attr('href');
			const $btn = $(`.collapsed[data-target="${href}"]`);
			$btn.click();
		});
	}
}
